(function ($) {
  "use strict";

  $(function () {
    function getParameterByName(name, url = window.location.href) {
      name = name.replace(/[\[\]]/g, "\\$&");
      const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
      const results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return "";
      return decodeURIComponent(results[2].replace(/\+/g, " "));
    }

    const c = getParameterByName("c");
    const t = getParameterByName("t");

    const select = $("#searchform select");
    const options = select.find("option");

    options.each(function () {
      if ($(this).val() === c || $(this).val() === t) {
        $(this).prop("selected", true);
      }
    });
  });
})(jQuery);
